import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import {
  FormEnums,
  NewFormButtonText,
} from "app/services/api/types/forms/enums/FormEnums";
import { View } from "ui/atoms/view";
import { ButtonIcon, ButtonLink, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { AssessmentHistoryTemplate } from "app/features/reporting/templates/AssessmentHistoryTemplate";
import GoBack from "ui/molecules/common/GoBack";
import { usePathname } from "expo-router";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";

export function MmseScreen() {
  const pathname = usePathname();

  const { resident } = useResidentContext();
  const newPath = pathname.split("/").slice(0, -1).join("/");

  return (
    <View className="resident-container">
      <View className="flex-row justify-between mb-4">
        <GoBack path={newPath} />
        <PermissionCheck permission={PermissionsEnums.FILL_FORM}>
          <ButtonLink href={`/residents/${resident?.id}/mmse/add`}>
            <ButtonIcon as={AddIcon} />
            <ButtonText>{NewFormButtonText[FormEnums.MMSE]}</ButtonText>
          </ButtonLink>
        </PermissionCheck>
      </View>
      <AssessmentHistoryTemplate
        tag={FormEnums.MMSE}
        residentId={resident?.id}
      />
    </View>
  );
}
